import { AppState } from '../types';

export const getAllSessions = (appState: AppState) =>
  appState.session.sessions.concat(appState.session.unweightedSessions);
